<template>
  <div class="basic-info">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form
          class="ant-advanced-search-form"
          layout="inline"
          :form="form"
          @submit="handleSearch"
        >
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item label="计划名称">
                <a-input
                  placeholder="请输入计划名称"
                  v-decorator="['planName']"
                  allowClear
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="定投类型">
                <a-select placeholder="请选择" allowClear v-decorator="['planType']">
                  <a-select-option :value="1">建仓投</a-select-option>
                  <a-select-option :value="2">解套投</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="定投产品">
                <a-select
                  mode="multiple"
                  placeholder="请选择定投产品"
                  :maxTagCount=1
                  :maxTagTextLength=10
                  v-decorator="['fundCodes']"
                >
                  <a-select-option
                    v-for="o in fundList"
                    :value="o.fundCode"
                    :key="o.fundCode"
                    >{{ o.fundCodeName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="expand">
              <a-col :md="6" :sm="8">
                <a-form-item label="客户姓名">
                  <a-input
                    allowClear
                    placeholder="请输入客户名称"
                    v-decorator="['customerName']"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="8" :lg="7" :md="10" :sm="24">
                <a-form-item label="资产总额" class="expected-rate">
                  <a-input
                    allowClear
                    placeholder="请输入最小值"
                    class="query-group-cust"
                    v-decorator="['marketValueStart']"
                    style="width: 41%"
                  ></a-input>
                  <span class="query-group-split-cust"></span>
                  <a-input
                    allowClear
                    placeholder="请输入最大值"
                    class="query-group-cust"
                    v-decorator="['marketValueEnd']"
                    style="width: 42%"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="8" :lg="7" :md="10" :sm="24">
                <a-form-item label="资产效益" class="expected-rate">
                  <a-input
                    allowClear
                    placeholder="请输入最小值"
                    class="query-group-cust"
                    v-decorator="['totalIncomeStart']"
                    style="width: 41%"
                  ></a-input>
                  <span class="query-group-split-cust"></span>
                  <a-input
                    allowClear
                    placeholder="请输入最大值"
                    class="query-group-cust"
                    v-decorator="['totalIncomeEnd']"
                    style="width: 42%"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="8" :lg="7" :md="10" :sm="24">
                <a-form-item label="已投期数" class="expected-rate">
                  <a-input
                    allowClear
                    placeholder="请输入最小值"
                    class="query-group-cust"
                    v-decorator="['cycleCountStart']"
                    style="width: 41%"
                  ></a-input>
                  <span class="query-group-split-cust"></span>
                  <a-input
                    allowClear
                    placeholder="请输入最大值"
                    class="query-group-cust"
                    v-decorator="['cycleCountEnd']"
                    style="width: 42%"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="计划状态">
                  <a-select
                    mode="multiple"
                    placeholder="请选择"
                    :maxTagCount=1
                    v-decorator="['multiState']"
                  >
                    <a-select-option v-for="(o, i) in investStatusText.ist1" :value="i" :key="i">{{o}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="达标状态">
                  <a-select placeholder="请选择" allowClear v-decorator="['targetStatus']">
                    <a-select-option :value="0">未达标</a-select-option>
                    <a-select-option :value="1">已达标</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="8">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleSearch" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="handleReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
                <a @click="toggle" style="margin-left: 8px">
                  {{ expand ? '收起' : '展开' }}
                  <a-icon :type="expand ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          size="middle"
          bordered
          :columns="columns"
          :data-source="fixedList"
          rowKey="id"
          :scroll="{ x: 1700 }"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          @change="handleTableChange"
          >
          <!-- 产品名称 -->
          <template slot="fundName" slot-scope="text, record">
            {{
              record.tdPlFunds &&
              record.tdPlFunds[0] &&
              record.tdPlFunds[0].fundName
                ? record.tdPlFunds[0].fundName
                : ''
            }}
          </template>
          <!-- 总市值 -->
          <template slot="marketValue" slot-scope="text, record">
            {{
              record.tdPlProfit && record.tdPlProfit.marketValue
                ? record.tdPlProfit.marketValue
                : ''
            }}
          </template>
          <!-- 资产收益 -->
          <template slot="totalIncome" slot-scope="text, record">
            {{
              record.tdPlProfit && record.tdPlProfit.totalIncome
                ? record.tdPlProfit.totalIncome
                : ''
            }}
          </template>
          <!-- 状态 -->
          <template slot="investStatus" slot-scope="text, record">
            <a-tag v-if="record.status || String(record.status)" :color="investStatusColor.isc1[record.status]">{{
              investStatusText.ist1[record.status]
            }}</a-tag>
            <a-tag v-if="record.targetStatus || String(record.targetStatus)" :color="investStatusColor.isc2[record.targetStatus]">{{
              investStatusText.ist2[record.targetStatus]
            }}</a-tag>
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleView(record.id,record.planType_dictText)">查看</a>
          </span>
        </a-table>
      </div>
    </a-card>
  </div>
</template>
<script>
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'; //下拉组件
import { fixedInvestment } from '@/api/api';
import Preview from '@/components/common/Preview';
import { getAction } from '@/api/manage.js';
const columns = [
  {
    title: '计划名称',
    align: 'center',
    dataIndex: 'planName',
    key: 'planName',
    width: 200,
  },
  {
    title: '定投类型',
    align: 'center',
    dataIndex: 'planType_dictText',
    key: 'planType_dictText',
    width: 150
  },
  {
    title: '定投产品',
    align: 'center',
    dataIndex: 'fundName',
    key: 'fundName',
    width: 200,
    scopedSlots: { customRender: 'fundName' },
  },
  {
    title: '客户姓名',
    align: 'center',
    dataIndex: 'customerCode',
    key: 'customerCode',
    width: 150,
  },
  {
    title: '资产总额（元）',
    align: 'center',
    dataIndex: 'marketValue',
    key: 'marketValue',
    width: 150,
    scopedSlots: { customRender: 'marketValue' },
  },
  {
    title: '资产效益（元）',
    align: 'center',
    dataIndex: 'totalIncome',
    key: 'totalIncome',
    width: 150,
    scopedSlots: { customRender: 'totalIncome' },
  },
  {
    title: '已投期数',
    align: 'center',
    dataIndex: 'cycleCount',
    key: 'cycleCount',
    width: 150,
  },
  {
    title: '状态',
    align: 'center',
    dataIndex: ['status', 'targetStatus'],
    key: 'targetStatus',
    width: 300,
    scopedSlots: { customRender: 'investStatus' },
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  data() {
    return {
      queryParam: {
        marketValueStart: '', // 资产总额
        marketValueEnd: '',
        totalIncomeStart: '', // 资产效益
        totalIncomeEnd: '',
        cycleCountStart: '', // 已投期数
        cycleCountEnd: '',
        multiState:[], //计划状态
        targetStatus: '', //达标
        planType: '', //定投类型
        planName: '', //计划名称
        customerName: '', //客户姓名
        fundCodes: [], //定投产品
      },
      columns,
      expand: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      fixedList: [
        {
          id: 1,
          planName: '111',
          investType: '1',
          investProduct: '2',
          customerName: '哈哈',
          totalAccets: 10,
          assetBenefit: 20,
          investNum: 5,
          investStatus1: 2,
          investStatus2: 1,
          investStatus3: 1,
        },
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      fundList: [], // 定投产品列表
      url: {
        productUrl:process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed/all', // 定投产品列表
      },
      investStatusColor: {
        isc1: ['orange', 'blue', 'red', ''],
        isc2: ['', 'green'],
      },
      investStatusText: {
        ist1: ['计划暂停中', '计划进行中', '计划已终止', '计划未开始'],
        ist2: ['未达标', '已达标'],
      },
    };
  },
  components: {
    JDictSelectTag,
    Preview,
  },
  created() {
    this.initTableData();
    this.productName();
  },
  methods: {
    // 获取表格数据
    initTableData(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      this.form.validateFields((error, values) => {
        let params = {
          ...values,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize,
        };
        that.loading = true;
        fixedInvestment(params).then((res) => {
          that.loading = false;
          if (res.success) {
            console.log(res.result.records, '====');
            that.fixedList = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      });
    },
    // 定投产品列表
    productName() {
      getAction(this.url.productUrl).then((res) => {
        if (res.success) {
          res.result.map((item) => {
            item.fundCodeName = item.fundName + '/' + item.fundCode;
          });
          this.fundList = res.result ? res.result : [];
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 清空表格选择
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    // 查询
    handleSearch(e) {
      e.preventDefault();
      this.initTableData();
    },
    // 重置
    handleReset() {
      this.form.resetFields();
      this.initTableData();
    },
    // 收起与展开
    toggle() {
      this.expand = !this.expand;
    },
    // 表格每项选择
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(selectionRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initTableData();
    },
    // 表格查看按钮
    handleView(id,planType_dictText) {
      this.$router.push({
        path: '/customer/fixedInvestment/fixedDetail',
        query: {
            id,
            planType_dictText
        }
      });
    },
    // 批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.ant-advanced-search-form {
  width: 100%;
  background: #fff;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
.table-operator {
  margin-bottom: 10px;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-control {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 100%;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-control:hover {
  border-color: #40a9ff;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-children
  input {
  border: none;
  height: 28px;
}
/deep/.expected-rate.ant-form-item input:focus {
  box-shadow: none;
}
</style>
